import { HttpGet } from "../utils/request";

export function capitalFlowListData(ticker, date) {
     return HttpGet(`/api/v3/mfsummary?ticker=${ticker}&date=${date}`)
}

export function capitalFlowChartData(ticker, frequency, date) {
     return HttpGet(`/api/v3/mfplot?ticker=${ticker}&frequency=${frequency}&date=${date}`)
}